var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_737_5497",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.9984,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_737_5497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 22C10.6161 22 9.31619 21.7373 8.09961 21.212C6.88302 20.6873 5.82475 19.975 4.92481 19.075C4.02487 18.175 3.31258 17.1167 2.78795 15.9C2.26265 14.6833 2 13.3833 2 12C2 10.6167 2.26265 9.31667 2.78795 8.1C3.31258 6.88333 4.02487 5.825 4.92481 4.925C5.82475 4.025 6.88302 3.31233 8.09961 2.787C9.31619 2.26233 10.6161 2 11.9994 2C13.3826 2 14.6825 2.26233 15.8991 2.787C17.1157 3.31233 18.174 4.025 19.0739 4.925C19.9738 5.825 20.6861 6.88333 21.2108 8.1C21.7361 9.31667 21.9987 10.6167 21.9987 12C21.9987 13.3833 21.7361 14.6833 21.2108 15.9C20.6861 17.1167 19.9738 18.175 19.0739 19.075C18.174 19.975 17.1157 20.6873 15.8991 21.212C14.6825 21.7373 13.3826 22 11.9994 22ZM11.9994 20C14.2159 20 16.1034 19.221 17.662 17.663C19.2199 16.1043 19.9988 14.2167 19.9988 12C19.9988 9.78333 19.2199 7.89567 17.662 6.337C16.1034 4.779 14.2159 4 11.9994 4C9.78283 4 7.89562 4.779 6.33772 6.337C4.77915 7.89567 3.99987 9.78333 3.99987 12C3.99987 14.2167 4.77915 16.1043 6.33772 17.663C7.89562 19.221 9.78283 20 11.9994 20Z",
    fill: "#969FCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9971 9.71569C11.6807 9.71578 11.3771 9.84035 11.1519 10.0625C11.0409 10.1723 10.9527 10.3029 10.8924 10.4469C10.8321 10.5909 10.8008 10.7454 10.8005 10.9015V16.9793C10.8003 17.1356 10.8312 17.2904 10.8913 17.4346C10.9513 17.5789 11.0393 17.7099 11.1503 17.8199C11.3758 18.0427 11.6801 18.1673 11.9971 18.1667C12.3136 18.1674 12.6175 18.0428 12.8423 17.8199C12.9534 17.71 13.0417 17.5791 13.102 17.4348C13.1623 17.2905 13.1935 17.1357 13.1937 16.9793V10.9015C13.1922 10.5864 13.0658 10.2846 12.8423 10.0625C12.617 9.84035 12.3134 9.71578 11.9971 9.71569Z",
    fill: "#969FCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.997 8.52833C12.2334 8.52859 12.4646 8.45853 12.6611 8.32707C12.8574 8.19692 13.0109 8.01163 13.1023 7.79452C13.1925 7.57775 13.2162 7.33902 13.1704 7.10873C13.1237 6.87787 13.0095 6.66608 12.8422 6.50032C12.6732 6.33216 12.4574 6.21887 12.223 6.17523C11.9908 6.12873 11.7501 6.1519 11.531 6.2418C11.3131 6.33235 11.1264 6.48463 10.9939 6.6799C10.8627 6.87482 10.7926 7.10444 10.7926 7.33939C10.7925 7.49567 10.8234 7.65042 10.8834 7.79471C10.9435 7.93899 11.0315 8.06996 11.1425 8.18001C11.3678 8.40321 11.6721 8.5284 11.9892 8.52833H11.997Z",
    fill: "#969FCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.5f8ff10787d512871c07839e4c794fe2.svg";
export { ForwardRef as ReactComponent };